import { STORAGE_KEYS } from '~/utils/storage'

const HISTORY_LIMIT = 10

// useSearchHistory 管理最近搜索关键词及本地持久化
export const useSearchHistory = () => {
  const keywords = useState<string[]>('blog-search-history', () => [])

  onMounted(() => {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEYS.SEARCH_HISTORY) || '[]')
      if (Array.isArray(stored)) {
        keywords.value = [...new Set(
          stored.filter((item): item is string => typeof item === 'string').map(item => item.trim()).filter(Boolean)
        )].slice(0, HISTORY_LIMIT)
      }
    } catch {
      // 本地记录不可用时保留当前会话历史
    }
  })

  // persist 保存或清空本地搜索历史
  const persist = () => {
    try {
      if (keywords.value.length) {
        localStorage.setItem(STORAGE_KEYS.SEARCH_HISTORY, JSON.stringify(keywords.value))
      } else {
        localStorage.removeItem(STORAGE_KEYS.SEARCH_HISTORY)
      }
    } catch {
      // 存储不可用时保留当前会话历史
    }
  }

  // remember 记录关键词并将最近搜索置顶
  const remember = (keyword: string) => {
    const value = keyword.trim()
    if (!value) {
      return
    }
    keywords.value = [value, ...keywords.value.filter(item => item !== value)].slice(0, HISTORY_LIMIT)
    persist()
  }

  // clear 清空搜索历史
  const clear = () => {
    keywords.value = []
    persist()
  }

  return { keywords: readonly(keywords), remember, clear }
}
